import { useFirebaseAuth } from "@kunduz/feature-firebase";
import { setUser } from "@sentry/nextjs";
import { useQueryClient } from "@tanstack/react-query";

export function useLogout() {
  const { signOutFromFirebase } = useFirebaseAuth();
  const queryClient = useQueryClient();

  const logoutFn = async () => {
    // clear firebase
    await signOutFromFirebase();
    // clear cookies
    await fetch("/api/auth/logout/", {
      method: "POST",
    });
    // clear sentry user
    setUser(null);

    // clear analytics
    if (typeof window !== "undefined") {
      window.analytics.reset();
    }
    // clear localstorage
    localStorage.clear();
    // clear sessionstorage
    sessionStorage.clear();
    queryClient.clear();
  };

  return {
    logoutFn,
  };
}
